"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/VariablesCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _format = require('web/screens/Broadcast/format');

var _Spinner = require('web/components/Spinner');






/* "Variables in this campaign": each variable's coverage among unsent
 * recipients, its CSV column, and the fallback the message gives it. */
const VariablesCard = ({ template, coverage }) => {
  const tokens = _broadcastTemplateTokens.templateTokens.call(void 0, template)
  return (
    _react2.default.createElement('div', { className: "broadcast-wizard--card broadcast-variables" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      , _react2.default.createElement('div', { className: "broadcast-wizard--card-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, _react2.default.createElement('h2', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "Variables in this campaign"   ))
      , _react2.default.createElement('div', { className: "broadcast-wizard--card-pad", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
        ,  !coverage
          ? _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 23}} )
          : coverage.map(c => {
            const fallback = _broadcastTemplateTokens.fallbackFor.call(void 0, tokens, c.Name)
            return (
              _react2.default.createElement('div', { key: c.Name, className: "broadcast-kv", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
                , _react2.default.createElement('span', { className: "broadcast-kv--key broadcast-wizard--mono" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}},  c.Name )
                , _react2.default.createElement('span', { className: "broadcast-kv--value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
                  ,  _format.formatCount.call(void 0, c.have) , " of "  ,  _format.formatCount.call(void 0, c.total) , " have a value"
                  , _react2.default.createElement('span', { className: "broadcast-kv--aside", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
                    ,  c.Source && _react2.default.createElement(_react2.default.Fragment, null, " · from “"   ,  c.Source , "”") 
                    ,  c.have < c.total && (
                      fallback !== null
                        ? _react2.default.createElement(_react2.default.Fragment, null, " · fallback “"   ,  fallback , "”")
                        : _react2.default.createElement(_react2.default.Fragment, null, " · no fallback"   )
                    )
                  )
                )
              )
            )
          })
        
      )
    )
  )
}

exports. default = VariablesCard
